import { render } from "./PantryUsedUpTitleView.vue?vue&type=template&id=68996dcc&ts=true"
import script from "./PantryUsedUpTitleView.vue?vue&type=script&lang=ts"
export * from "./PantryUsedUpTitleView.vue?vue&type=script&lang=ts"

import "./PantryUsedUpTitleView.vue?vue&type=style&index=0&id=68996dcc&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__